import { render } from "./bank_accounts.vue?vue&type=template&id=ce8b641a&scoped=true"
import script from "./bank_accounts.vue?vue&type=script&lang=js"
export * from "./bank_accounts.vue?vue&type=script&lang=js"

import "./bank_accounts.vue?vue&type=style&index=0&id=ce8b641a&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8b641a"]])

export default __exports__